import {
  initTracerError,
  initTracerErrorAsyncStack,
  initTracerErrorUploader,
  initTracerLog,
  initTracerSessionUploader,
  initTracerWebVitals,
  initTracerWebVitalsUploader,
} from '@tracer/sdk';

import './commonPolyfills';
import filterError from './filterError';
import './polyfills';
import writeConsoleToLog from './writeConsoleToLog';

const isValidHost = window.location.host === 'www.rustore.ru';

const isWebView = (() => {
  try {
    return navigator.userAgent?.includes('wv)');
  } catch {
    return false;
  }
})();

const getCookies = () => {
  try {
    return document.cookie
      .split(';')
      .filter((item) => !!item)
      .map((item) => item.trim().split('='))
      .reduce((acc, [cookieName, cookieValue]) => {
        acc[cookieName] = cookieValue;
        return acc;
      }, {});
  } catch (e) {
    return {};
  }
};

if (isValidHost) {
  const config = {
    versionName: process.env.TRACER_VERSION_NAME,
    versionCode: Number.parseInt(process.env.TRACER_VERSION_CODE),
    appToken: process.env.TRACER_APP_TOKEN,
  };

  const tracer = initTracerError({filterError});

  const cookies = getCookies();

  tracer.setErrorKeys({
    pathname: window.location.pathname,
    query: window.location.search,
    initialPath: window.location.pathname,
    referrer: window.document.referrer,
    isWebView,
    webViewPackageName: cookies['_wv_pn'] || '',
    oid: cookies['oid'] || '',
  });

  initTracerErrorUploader(config);
  initTracerSessionUploader(config);

  initTracerWebVitals({
    addMetricAttributes: () => ({pathname: location.pathname}),
  });

  initTracerWebVitalsUploader(config);

  initTracerErrorAsyncStack();

  if (typeof window._tracer_module === 'string') {
    tracer.setModule(window._tracer_module);
  }

  const logger = initTracerLog();

  writeConsoleToLog(logger);
}
